
namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MemberTypeDialog extends Serenity.EntityDialog<MemberTypeRow, any> {
        protected getFormKey() { return MemberTypeForm.formKey; }
        protected getIdProperty() { return MemberTypeRow.idProperty; }
        protected getLocalTextPrefix() { return MemberTypeRow.localTextPrefix; }
        protected getNameProperty() { return MemberTypeRow.nameProperty; }
        protected getService() { return MemberTypeService.baseUrl; }
        protected getDeletePermission() { return MemberTypeRow.deletePermission; }
        protected getInsertPermission() { return MemberTypeRow.insertPermission; }
        protected getUpdatePermission() { return MemberTypeRow.updatePermission; }

        protected form = new MemberTypeForm(this.idPrefix);

        constructor() {
            super();
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close::after"), 1);

            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.deleteButton.hide();
            this.saveAndCloseButton.hide();
            this.cloneButton.hide();

            
        }
    }
}
